export default __webpack_public_path__ + "static/media/edb.25fbb047.jpg";